/*
 * Rooana: визуален избор на нюанс в комплектите (sections/rooana-product-set + snippets/rooana-set-row).
 * - Кръгчетата се оцветяват от снимката на варианта (canvas, доминантен наситен цвят).
 * - Ключови думи в името на нюанса имат предимство (напр. black, olive, grey), защото опаковката подвежда извличането.
 * - Ако цвят не може да се определи, остава мини снимка на варианта.
 * - Клик върху кръгче сменя скрития select -> rooana-addons.js обновява цената и сумата; тук сменяме снимката и етикета.
 */
(function () {
  var KEYWORDS = [
    [/olive/i, '#6a6b3b'],
    [/black/i, '#1d1b1c'],
    [/\bgrey\b/i, '#77767a']
  ];

  function fromKeyword(title) {
    for (var i = 0; i < KEYWORDS.length; i++) {
      if (KEYWORDS[i][0].test(title || '')) return KEYWORDS[i][1];
    }
    return null;
  }

  function setColor(btn, color) {
    btn.style.setProperty('--sw', color);
    btn.classList.add('has-color');
  }

  function paint(btn) {
    if (btn.dataset.swDone) return;
    btn.dataset.swDone = '1';
    var kw = fromKeyword(btn.getAttribute('title'));
    if (kw) return setColor(btn, kw);
    var src = btn.dataset.swSrc;
    if (!src) return;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var s = 80, c = document.createElement('canvas');
        c.width = s; c.height = s;
        var x = c.getContext('2d');
        x.drawImage(im, 0, 0, s, s);
        var d = x.getImageData(0, 0, s, s).data, b = {};
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], g = d[i + 1], bl = d[i + 2];
          var mx = Math.max(r, g, bl), mn = Math.min(r, g, bl);
          if (mn > 225) continue;
          var sat = mx ? (mx - mn) / mx : 0;
          if (sat < 0.18 || mx < 40) continue;
          var k = (r >> 5) + ',' + (g >> 5) + ',' + (bl >> 5);
          var e = (b[k] = b[k] || [0, 0, 0, 0, 0]);
          e[0] += r; e[1] += g; e[2] += bl; e[3]++; e[4] += sat;
        }
        var best = null, bs = 0;
        for (var key in b) {
          var en = b[key], sc = en[3] * Math.pow(en[4] / en[3], 1.5);
          if (sc > bs) { bs = sc; best = en; }
        }
        if (!best || best[3] < 6) return;
        var rgb = [best[0] / best[3], best[1] / best[3], best[2] / best[3]].map(Math.round);
        setColor(btn, 'rgb(' + rgb.join(',') + ')');
      } catch (err) {}
    };
    im.src = src;
  }

  function paintAll(root) {
    (root || document).querySelectorAll('.rooana-srow__swatch').forEach(paint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paintAll(); });
  } else {
    paintAll();
  }

  if (window.__rooanaSetSwatches) return;
  window.__rooanaSetSwatches = true;

  document.addEventListener('shopify:section:load', function (e) { paintAll(e.target); });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-swatch]');
    if (!b) return;
    var row = b.closest('[data-rooana-row]');
    var sel = row && row.querySelector('select[data-rooana-variant]');
    if (!sel || sel.value === b.dataset.swatch) return;
    sel.value = b.dataset.swatch;
    row.querySelectorAll('[data-swatch]').forEach(function (x) {
      var on = x === b;
      x.classList.toggle('is-selected', on);
      x.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.rooana-srow select[data-rooana-variant]');
    if (!sel) return;
    var row = sel.closest('[data-rooana-row]');
    var o = sel.options[sel.selectedIndex];
    var lab = row.querySelector('[data-rooana-shade]');
    if (lab && o) lab.textContent = o.dataset.title;
    var img = row.querySelector('.rooana-srow__media img');
    if (img && o && o.dataset.img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = o.dataset.img;
    }
  });
})();